import {
  toWSDate,
  WSTable,
  WSTableColumnSortDirection,
  WSTableItem
} from "@wingspanhq/fe-component-library";
import { Transaction } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { getColumns } from "./columns";

export type TableItemData = Transaction;

const getMonthGroupName = (date?: Date): string => {
  if (!date) {
    return "No date";
  }
  const parsed = new Date(date);
  const month = toWSDate(parsed, "month").toString();
  return parsed.getFullYear() === new Date().getFullYear()
    ? month
    : `${month} ${parsed.getFullYear()}`;
};

type Props = {
  transactions: Transaction[];
  accountNameById: Map<string, string>;
  loading?: boolean;
  dateDirection?: WSTableColumnSortDirection;
  onSortByDate: (direction: WSTableColumnSortDirection) => void;
  onRowClick?: (transaction: Transaction) => void;
  selection?: WSTableItem<Transaction>[];
  onSelectionChange?: (selection: WSTableItem<Transaction>[]) => void;
};

export const TableTransactions: React.FC<Props> = props => {
  const tableData = useMemo(
    () =>
      props.transactions.map(transaction => ({
        id: transaction.id,
        data: transaction
      })),
    [props.transactions]
  );

  const columns = useMemo(
    () =>
      getColumns({
        accountNameById: props.accountNameById,
        onSortByDate: props.onSortByDate,
        dateDirection: props.dateDirection
      }),
    [props.accountNameById, props.onSortByDate, props.dateDirection]
  );

  return (
    <WSTable<TableItemData>
      loading={props.loading}
      showHeader
      columns={columns}
      getGroupName={item => getMonthGroupName(item.data.date)}
      tableData={tableData}
      selection={props.selection}
      onSelectionChange={props.onSelectionChange}
      onRowClick={
        props.onRowClick ? item => props.onRowClick!(item.data) : undefined
      }
    />
  );
};
